var _rect, _rect2, _rect3, _circle, _circle2, _circle3, _text, _text2, _rect4, _circle4, _path, _rect5, _rect6, _rect7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 750",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 750,
    fill: "#10243b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 610,
    rx: 26,
    fill: "#f4f7fb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 70,
    width: 1060,
    height: 82,
    rx: 26,
    fill: "#1877c9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 111,
    r: 12,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 111,
    r: 12,
    fill: "#b9e4ff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 111,
    r: 12,
    fill: "#65baf0"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 240,
    fontFamily: "Arial",
    fontSize: 58,
    fontWeight: 700,
    fill: "#12243b"
  }, "Findora")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 290,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "#61748b"
  }, "Search smarter. Move faster.")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 350,
    width: 720,
    height: 70,
    rx: 35,
    fill: "#e7eef5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 790,
    cy: 385,
    r: 25,
    fill: "#1877c9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m780 375 18 18m0-18-18 18",
    stroke: "#fff",
    strokeWidth: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 480,
    width: 260,
    height: 80,
    rx: 14,
    fill: "#d4e8fa"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 480,
    width: 260,
    height: 80,
    rx: 14,
    fill: "#e8eef4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 480,
    width: 260,
    height: 80,
    rx: 14,
    fill: "#e8eef4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindora);
export default __webpack_public_path__ + "static/media/findora.1613a1905f0dbb4c600a98c43f6c69e2.svg";
export { ForwardRef as ReactComponent };